import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { meQueryOptions } from '~/lib/auth';
import { departmentsQueryOptions } from '~/lib/departments';

export function resolveOrgId(queryClient: QueryClient, orgSlug: string): string {
  const session = queryClient.getQueryData(meQueryOptions.queryKey);
  if (!session) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/login' });
  }
  if (session.orgSlug !== orgSlug) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/jobs' });
  }
  return session.orgId;
}

export function resolveDeptId(queryClient: QueryClient, deptSlug: string): string {
  const data = queryClient.getQueryData(departmentsQueryOptions.queryKey);
  const dept = data?.departments.find((d) => d.slug === deptSlug);
  if (!dept) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/jobs' });
  }
  return dept.id;
}

export function resolveSlugIds(
  queryClient: QueryClient,
  orgSlug: string,
  deptSlug?: string
): { orgId: string; deptId?: string } {
  const orgId = resolveOrgId(queryClient, orgSlug);
  const deptId = deptSlug ? resolveDeptId(queryClient, deptSlug) : undefined;
  return { orgId, deptId };
}
